var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.682 12.182-7.864-7.864A4.5 4.5 0 0 0 32.636 3H7.5A4.5 4.5 0 0 0 3 7.5v33A4.5 4.5 0 0 0 7.5 45h33a4.5 4.5 0 0 0 4.5-4.5V15.364a4.5 4.5 0 0 0-1.318-3.182zM28.5 7.5V15h-12V7.5h12zm11.438 33H8.061a.562.562 0 0 1-.562-.563V8.064c0-.311.252-.563.563-.563H12v9.75a2.25 2.25 0 0 0 2.25 2.25h16.5A2.25 2.25 0 0 0 33 17.25V7.864l7.335 7.335a.563.563 0 0 1 .165.398v24.34c0 .311-.252.563-.563.563zM24 21.75c-4.549 0-8.25 3.701-8.25 8.25 0 4.549 3.701 8.25 8.25 8.25 4.549 0 8.25-3.701 8.25-8.25 0-4.549-3.701-8.25-8.25-8.25zm0 12A3.754 3.754 0 0 1 20.25 30 3.754 3.754 0 0 1 24 26.25 3.754 3.754 0 0 1 27.75 30 3.754 3.754 0 0 1 24 33.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.41996f2db15b5e15208c1c35d975244a.svg";
export { ForwardRef as ReactComponent };